import { render, staticRenderFns } from "./address_management.vue?vue&type=template&id=184f4291&scoped=true"
import script from "./address_management.vue?vue&type=script&lang=js"
export * from "./address_management.vue?vue&type=script&lang=js"
import style0 from "./address_management.vue?vue&type=style&index=0&id=184f4291&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184f4291",
  null
  
)

export default component.exports